<template>
  <Widget :title="title" hide-details title-type="bold">
    <div class="widget-body">
      <template v-if="!isLoading">
        <slot />
      </template>
      <div v-else class="loader">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
  </Widget>
</template>

<script>
import Widget from "@/components/Dashboard/base/Widget";

export default {
  name: "ReviewsCategoriesCard",
  components: {
    Widget
  },
  props: {
    title: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: $grey-darker;
}
.loader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
